import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { accessDeniedContainer, accessDeniedTitle, accessDeniedMessage, accessDeniedButton } from './styles';
import accessDeniedIcon from '../../../accessDenied.svg';
import routes from '../../constants/routes';

function AccessDenied() {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box sx={accessDeniedContainer} data-testid='access-denied-page'>
      <Box sx={{ display: 'flex', justifyContent: 'center', mr: 8 }}>
        <img src={accessDeniedIcon} alt='access-denied' style={{ width: '340px', height: '240px' }} />
      </Box>
      <Typography variant='h4' color='textSecondary' align='center' sx={accessDeniedTitle(theme)}>
        {t('global.accessDenied')}
      </Typography>
      <Typography variant='body1' color='textSecondary' align='center' sx={accessDeniedMessage(theme)}>
        {t('global.accessDeniedMessage')}
      </Typography>
      <Button
        data-testid='return-home-button'
        variant='contained'
        onClick={() => {
          window.location.href = process.env.REACT_APP_HOME_URL || routes.HOME_PAGE;
        }}
        sx={accessDeniedButton(theme)}
      >
        {t('global.returnHome')}
      </Button>
    </Box>
  );
}

export default AccessDenied;
